import { DateTime } from 'luxon'

import { digObject } from '@domain-group/javascript-utils'
import {
  Box, Image, ListItem, Text,
} from '@domain-group/suit-theme'

import useSavedArtworkPage from '@hooks/useSavedArtworkPage'

import { SavedArtworkPageModel } from '@models/types'

import placeholderImageUrl from '../../../../../../assets/placeholder.svg'

import styles from './styles.module.scss'

type SavedArtworkPageGridItemProps = {
  entity: SavedArtworkPageModel,
}

const SavedArtworkPageGridItem = (props: SavedArtworkPageGridItemProps) => {
  const { entity: savedArtworkPage } = props

  const {
    callbacks: { launchManageSavedArtworkPageModal },
    savedArtwork,
    user,
  } = useSavedArtworkPage(savedArtworkPage)

  const { title } = savedArtworkPage
  const { title: savedArtworkTitle } = savedArtwork || {}

  const createdDateTime = digObject(savedArtworkPage, 'dates.created.date_time')
  const thumbUrl = digObject(savedArtworkPage, 'previews.thumb', '')

  const createdDateTimeFormatted = DateTime.fromFormat(
    createdDateTime,
    'dd/MM/yyyy HH:mm',
  ).toFormat('h:mm a dd/MM/yyyy ')

  return (
    <Box
      className={styles.root}
      flexDirection="column"
      onClick={() => launchManageSavedArtworkPageModal()}
      variant="white"
    >
      <Image
        backgroundSize="contain"
        borderRadius="5px 5px 0 0"
        boxProps={{ backgroundColor: 'whiteGrey' }}
        height={150}
        placeholderUrl={placeholderImageUrl}
        url={thumbUrl}
      />

      <Box borderTop="1px solid" borderColor="lineColor" flexDirection="column" padding="large" paddingTop={0}>
        <ListItem
          boxProps={{ borderBottom: '1px dashed', paddingY: 'large' }}
          flexDirection="column"
          showAngleIcon
        >
          <Text fontSize="small" variant="ellipsis">{title}</Text>

          <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" variant="ellipsis">
            {`${user.full_name} ${createdDateTimeFormatted}`}
          </Text>
        </ListItem>

        <ListItem
          boxProps={{ borderBottom: '1px dashed', paddingTop: 'large' }}
          flexDirection="column"
        >
          <Text fontSize="small">{`Saved Page #${savedArtworkPage.id}`}</Text>

          {savedArtworkTitle && (
            <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="small" variant="ellipsis">
              {`Saved In: ${savedArtworkTitle}`}
            </Text>
          )}
        </ListItem>
      </Box>
    </Box>
  )
}

export default SavedArtworkPageGridItem
